export enum LeaveTime {
  FULL_DAY = 'FULL_DAY',
  AM = 'AM',
  PM = 'PM',
}
